<template>
  <div>
    <div class="lf eventCategory w326 ml  ">
      <div class="inner-wrap">
        <div class="argument-warp">
          <div class="fl" id="myChartMap" style="width:100%;height:100%;"></div>
        </div>
      </div>
      <title-h3 :titlemsg="titlemsg4"></title-h3>
    </div>
  </div>
</template>


<script>
  import * as echarts from 'echarts';
  import geoJson from '../../../static/js/xian.json'
  import title from '../title'
  export default {
    name: 'eventCategory',
    data() {
      return {
        geoJson: geoJson,
        titlemsg4: '商户分布图',
        timer: null
      }
    },
    watch: {
      echarts() {
        //调用定时器
        this.timer();
      }
    },
    mounted() {
      this.drawLine(geoJson);
    },
    methods: {
      setInter() {

        // let that = this        //  return setTimeout(() => {
        //   this.drawLine();          }, 3000)      },
    //西安地图
    drawLine(dataJson) {
      let that = this
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChartMap'));
      myChart.showLoading()
      echarts.registerMap('xian', dataJson)
      myChart.hideLoading()
      let geoCoordMap = {

        新城区: [108.959903,34.26927],
        碑林区: [108.946994,34.251061],
        莲湖区: [108.933194,34.2656],
        灞桥区: [109.067261,34.267453],
        未央区: [108.946022,34.30823],
        雁塔区: [108.926593,34.213389],
        阎良区: [109.22802,34.662141],
        临潼区: [109.213986,34.372065],
        长安区: [108.941579,34.157097],
        高陵区: [109.088896,34.535065],
        鄠邑区: [108.607385,34.108668],
        蓝田县: [109.317634,34.156189],
        周至县: [108.216465,34.161532]
      }
      let data = [
        {
          name: '新城区',
          value: 199
        },
        {
          name: '碑林区',
          value: 39
        },
        {
          name: '莲湖区',
          value: 152
        },
        {
          name: '灞桥区',
          value: 299
        },
        {
          name: '未央区',
          value: 59
        },
        {
          name: '雁塔区',
          value: 33
        },
        {
          name: '阎良区',
          value: 349
        },
        {
          name: '临潼区',
          value: 239
        },
        {
          name: '长安区',
          value: 35
        },
        {
          name: '高陵区',
          value: 24
        },
        {
          name: '鄠邑区',
          value: 34
        },
        {
          name: '蓝田县',
          value: 32
        },
        {
          name: '周至县',
          value: 87
        }
      ]
      let convertData = function(sourse) {
        let res = []
        for (let i = 0; i < sourse.length; i++) {
          let geoCoord = geoCoordMap[sourse[i].name]
          if (geoCoord) {
            res.push({
              name: sourse[i].name,
              value: geoCoord.concat(sourse[i].value)
            })
          }
        }
        return res
      }
      let option = {
        tooltip: {
          show: false
        },
        geo: {
          show: true,
          map: 'xian',
          zoom: 1.0,
          roam: true,
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false,
              textStyle: {
                color: '#fff'
              }
            }
          },
          itemStyle: {
            normal: {
              areaColor: '#0d3145', // 地图背景颜色
              borderColor: '#0ff' // 地图边界颜色
            },
            emphasis: {
              show: false,
              areaColor: '#0d3145', // 鼠标经过地图背景颜色
              color: '#ddd'
            }
          }
        },
        series: [
          {
            name: 'credit_pm2.5',
            type: 'scatter',
            coordinateSystem: 'geo',
            data: convertData(data),
            symbolSize: 5,
            label: {
              normal: {
                formatter: '{b}',
                position: 'right',
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: '#fff'
              }
            }
          },
          {
            type: 'map',
            map: 'xian',
            geoIndex: 0,
            aspectScale: 3, // 长宽比
            showLegendSymbol: false, // 存在legend时显示
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false,
                textStyle: {
                  color: '#fff'
                }
              }
            },
            roam: true,
            itemStyle: {
              normal: {
                areaColor: '#031525',
                borderColor: '#3B5077'
              },
              emphasis: {
                areaColor: '#2B91B7'
              }
            },
            animation: false,
            data: data
          },
          {
            // 水滴
            name: '点',
            type: 'scatter',
            coordinateSystem: 'geo',
            symbol: 'pin',
            symbolSize: [50, 50],
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: '#fff',
                  fontSize: 9
                },
                formatter(value) {
                  return value.data.value[2]
                }
              }
            },
            itemStyle: {
              normal: {
                color: '#D8BC37' // 标志颜色
              }
            },
            zlevel: 6,
            data: convertData(data)
          }
        ]
      }
      myChart.setOption(option)

      // 使用刚指定的配置项和数据显示图表。
      // myChart.setOption(option);
      // this.setInter();
    },
  },
  components: {
    'title-h3': title
  }
  }
</script>
<style scoped>
  .eventCategory {
    width: 40%;
    height: 4.14rem;
  }

  .eventCategory .inner-wrap {
    /* height: 3.64rem; */
    height: 40vh;
    width: 100%;
    border-radius: 4px;
    padding-top: .08rem;
    overflow: hidden
  }

  .eventCategory .argument-warp {
    width: 100%;
    /* height: 3.54rem; */
    height: 100%;
    margin: 0 auto;
    border-radius: 4px;
  }

  .w326 {
    width: 32.604%
  }

  #myChartEP {
    /* width: 40%; */
    /* margin: 0 auto; */
    /* height: 4rem; */
    /* padding-top: .215rem; */
    /* overflow: hidden */
  }

  #myChartEB {
    width: 50%;
    margin-left: 6%
  }
</style>



// WEBPACK FOOTER //
// src/components/emergencyManage/scenicStatistics.vue